import { apiClient } from "@/api/client";
import type { CommissionOverview, CommissionSettings } from "@/types/domain";

/**
 * GET /admin/commission?from&to — delegates to apps/commission-service's
 * admin overview (per-driver gross/commission/collected/pending for the
 * period, plus totals). There is no separate "remind driver" endpoint in the
 * backend, so that action is intentionally not exposed in the UI.
 */
export const commissionApi = {
  getOverview: (params?: { from?: string; to?: string }) =>
    apiClient
      .get<CommissionOverview>("/admin/commission", { params })
      .then((r) => r.data),
  getSettings: () =>
    apiClient.get<CommissionSettings>("/admin/commission/settings").then((r) => r.data),
  updateSettings: (payload: Partial<CommissionSettings>) =>
    apiClient.patch<CommissionSettings>("/admin/commission/settings", payload).then((r) => r.data),
};
